import { render, staticRenderFns } from "./OccasionListItem.vue?vue&type=template&id=32eda9e5&"
import script from "./OccasionListItem.vue?vue&type=script&lang=js&"
export * from "./OccasionListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../themes/custom/ef2_custom/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports